exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.has-error .multiselect__tags {\n  border-color: #e40909;\n}\n", ""]);

// exports
